import { render, staticRenderFns } from "./KETConstructionDefects.vue?vue&type=template&id=1aaa6781&"
import script from "./KETConstructionDefects.vue?vue&type=script&lang=js&"
export * from "./KETConstructionDefects.vue?vue&type=script&lang=js&"
import style0 from "./KETConstructionDefects.vue?vue&type=style&index=0&id=1aaa6781&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports